import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import { SelfServiceCorp, ICorpUI } from 'src/types/Corp';

export const getCorporateSelfEndpoint = (corpId: string): string =>
  `/corp-admin/corp/self/${corpId}`;

export async function getSelfServiceCorporateData(
  corpId: string
): Promise<ICorpUI> {
  const response = await sdk.http.get(getCorporateSelfEndpoint(corpId));
  const data = get(response, 'object') as SelfServiceCorp;

  return camelizeResponseData(data);
}
